import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
// 非自主提现 公会长发放 is_cash_out: 0 共用一套接口
// 公会长前端查看结算数据 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=15314826
export const getUnionSettlementInfo = createAsyncThunk(
  'UnionSettlement/getUnionSettlementInfo',
  async (p: any, store: any) => {
    const {page_size: limit, page: offset, ...rest} = p
    const resp = await http.post('/live/union/get_live_settlement', {
      ...store.getState().env.deviceinfo,
      ...rest,
      limit: limit || 1,
      offset,
      is_cash_out: 0,
    })
    return {data: resp.data, page: p.page}
  }
)
// 自主提现 hiya发放 is_cash_out: 1 共用一套接口
// 公会长前端查看结算数据 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=15314826
export const getUnionSettlementCashoutList = createAsyncThunk(
  'UnionSettlement/getUnionSettlementCaseoutList',
  async (p: any, store: any) => {
    const {page_size: limit, page: offset, ...rest} = p
    const resp = await http.post('/live/union/get_live_settlement', {
      ...store.getState().env.deviceinfo,
      ...rest,
      limit: limit || 1,
      offset,
      is_cash_out: 1,
    })
    return {data: resp.data, page: p.page}
  }
)

export const confirmSettlement = createAsyncThunk(
  'UnionSettlement/confirmSettlement',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/confirm_settlement', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

const initialState: {
  union_settlement: any
  anchor_settlement: any[]
  page: number
  total: number
  cashoutInfo: any
  more: boolean
} = {
  union_settlement: {},
  anchor_settlement: [],
  page: 1,
  total: 0,
  more: false,
  cashoutInfo: {
    anchor_settlement: [],
    page: 1,
    total: 0,
  },
}

export const UnionSettlementSlice = createSlice({
  name: 'UnionSettlement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 这里其实是页面的总数据 settlementInfo 用于工会主自己发放薪资的部分
    builder.addCase(getUnionSettlementInfo.fulfilled, (state, action) => {
      const {
        data: {data},
        page,
      } = action.payload
      if (page === 0) {
        // 第一次请求
        Object.assign(state, {
          ...data,
          page: data.offset || 1,
        })
        return
      }
      Object.assign(state, {
        ...data,
        anchor_settlement: [
          ...state.anchor_settlement,
          ...data.anchor_settlement,
        ],
        page: data.offset || 1,
      })
    })
    builder.addCase(
      getUnionSettlementCashoutList.fulfilled,
      (state, action) => {
        const {
          data: {data},
          page,
        } = action.payload
        if (page === 0) {
          // : page + 1
          // 第一次请求
          Object.assign(state, {cashoutInfo: {...data, page: data.offset || 1}})
          return
        }
        // : page + 1
        Object.assign(state, {
          cashoutInfo: {
            ...data,
            anchor_settlement: [
              // 从此使用cashoutInfo指代自主提现的数据
              ...state.cashoutInfo.anchor_settlement,
              ...data.anchor_settlement,
            ],
            page: data.offset || 1,
          },
        })
      }
    )
  },
})

export default UnionSettlementSlice.reducer
